<template>
    <div>
        <div class="face">
            <ul>
                <li @click="dianji(index)" v-for="(item,index) in list" :key="item.img"><img  ref="src" :src="item.url" :title="item.title"></li>
            </ul>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import VueEvent from '../../api/eventBus'
export default {
    data(){
        return{
            list:[
                {url:"http://www.rujiaowang.net/space/img/emoji/smilea_thumb.gif",title:"呵呵"},
                {url:"http://www.rujiaowang.net/space/img/emoji/tootha_thumb.gif",title:"嘻嘻"},
                {url:"http://www.rujiaowang.net/space/img/emoji/laugh.gif",title:"哈哈"},
                {url:"http://www.rujiaowang.net/space/img/emoji/tza_thumb.gif",title:"可爱"},
                {url:"http://www.rujiaowang.net/space/img/emoji/kl_thumb.gif",title:"可怜"},
                {url:"http://www.rujiaowang.net/space/img/emoji/kbsa_thumb.gif",titl:"挖鼻屎"},
                {url:"http://www.rujiaowang.net/space/img/emoji/cj_thumb.gif",title:"吃惊"},
                {url:"http://www.rujiaowang.net/space/img/emoji/shamea_thumb.gif",title:"害羞"},
                {url:"http://www.rujiaowang.net/space/img/emoji/zy_thumb.gif",title:"挤眼"},
                {url:"http://www.rujiaowang.net/space/img/emoji/bz_thumb.gif",title:"闭嘴"},
                {url:"http://www.rujiaowang.net/space/img/emoji/bs2_thumb.gif", title:"鄙视"},
                {url:"http://www.rujiaowang.net/space/img/emoji/lovea_thumb.gif", title:"爱你"},
                {url:"http://www.rujiaowang.net/space/img/emoji/shamea_thumb.gif", title:"泪"},
                {url:"http://www.rujiaowang.net/space/img/emoji/heia_thumb.gif", title:"偷笑"},
                {url:"http://www.rujiaowang.net/space/img/emoji/qq_thumb.gif", title:"亲亲"},
                {url:"http://www.rujiaowang.net/space/img/emoji/sb_thumb.gif", title:"生病"},
                {url:"http://www.rujiaowang.net/space/img/emoji/mb_thumb.gif", title:"太开心"},
                {url:"http://www.rujiaowang.net/space/img/emoji/ldln_thumb.gif", title:"懒得理你"},
                {url:"http://www.rujiaowang.net/space/img/emoji/yhh_thumb.gif", title:"右哼哼"},
                {url:"http://www.rujiaowang.net/space/img/emoji/zhh_thumb.gif", title:"左哼哼"},
                {url:"http://www.rujiaowang.net/space/img/emoji/x_thumb.gif", title:"嘘"},
                {url:"http://www.rujiaowang.net/space/img/emoji/cry.gif", title:"衰"},
                {url:"http://www.rujiaowang.net/space/img/emoji/wq_thumb.gif", title:"委屈"},
                {url:"http://www.rujiaowang.net/space/img/emoji/t_thumb.gif", title:"吐"},
                {url:"http://www.rujiaowang.net/space/img/emoji/k_thumb.gif", title:"打哈气"},
                {url:"http://www.rujiaowang.net/space/img/emoji/bba_thumb.gif", title:"抱抱"},
                {url:"http://www.rujiaowang.net/space/img/emoji/angrya_thumb.gif", title:"怒"},
                {url:"http://www.rujiaowang.net/space/img/emoji/yw_thumb.gif", title:"疑问"},
                {url:"http://www.rujiaowang.net/space/img/emoji/cza_thumb.gif", title:"馋嘴"},
                {url:"http://www.rujiaowang.net/space/img/emoji/88_thumb.gif", title:"拜拜"},
                {url:"http://www.rujiaowang.net/space/img/emoji/sk_thumb.gif", title:"思考"},
                {url:"http://www.rujiaowang.net/space/img/emoji/sweata_thumb.gif", title:"汗"},
                {url:"http://www.rujiaowang.net/space/img/emoji/sleepya_thumb.gif", title:"困"},
                {url:"http://www.rujiaowang.net/space/img/emoji/sleepa_thumb.gif", title:"睡觉"},
                {url:"http://www.rujiaowang.net/space/img/emoji/money_thumb.gif", title:"钱"},
                {url:"http://www.rujiaowang.net/space/img/emoji/sw_thumb.gif", title:"失望"},
                {url:"http://www.rujiaowang.net/space/img/emoji/cool_thumb.gif", title:"酷"},
                {url:"http://www.rujiaowang.net/space/img/emoji/hsa_thumb.gif", title:"花心"},
                {url:"http://www.rujiaowang.net/space/img/emoji/hatea_thumb.gif", title:"哼"},
                {url:"http://www.rujiaowang.net/space/img/emoji/gza_thumb.gif", title:"鼓掌"},
                {url:"http://www.rujiaowang.net/space/img/emoji/dizzya_thumb.gif", title:"晕"},
                {url:"http://www.rujiaowang.net/space/img/emoji/bs_thumb.gif", title:"悲伤"},
                {url:"http://www.rujiaowang.net/space/img/emoji/crazya_thumb.gif", title:"抓狂"},
                {url:"http://www.rujiaowang.net/space/img/emoji/h_thumb.gif", title:"黑线"},
                {url:"http://www.rujiaowang.net/space/img/emoji/yx_thumb.gif", title:"阴险"},
                {url:"http://www.rujiaowang.net/space/img/emoji/nm_thumb.gif", title:"怒骂"},
                {url:"http://www.rujiaowang.net/space/img/emoji/hearta_thumb.gif", title:"心"},
                {url:"http://www.rujiaowang.net/space/img/emoji/unheart.gif", title:"伤心"},
                {url:"http://www.rujiaowang.net/space/img/emoji/pig.gif", title:"猪头"},
                {url:"http://www.rujiaowang.net/space/img/emoji/ok_thumb.gif", title:"ok"},
                {url:"http://www.rujiaowang.net/space/img/emoji/ye_thumb.gif", title:"耶"},
                {url:"http://www.rujiaowang.net/space/img/emoji/good_thumb.gif", title:"good"},
                {url:"http://www.rujiaowang.net/space/img/emoji/no_thumb.gif", title:"不要"},
                {url:"http://www.rujiaowang.net/space/img/emoji/z2_thumb.gif", title:"赞"},
                {url:"http://www.rujiaowang.net/space/img/emoji/come_thumb.gif", title:"来"},
                {url:"http://www.rujiaowang.net/space/img/emoji/sad_thumb.gif", title:"弱"},
                {url:"http://www.rujiaowang.net/space/img/emoji/lazu_thumb.gif", title:"蜡烛"},
                {url:"http://www.rujiaowang.net/space/img/emoji/clock_thumb.gif", title:"钟"},
                {url:"http://www.rujiaowang.net/space/img/emoji/cake.gif", title:"蛋糕"},
                {url:"http://www.rujiaowang.net/space/img/emoji/m_thumb.gif", title:"话筒"},
                {url:"http://www.rujiaowang.net/space/img/emoji/weijin_thumb.gif", title:"围脖"},
                {url:"http://www.rujiaowang.net/space/img/emoji/lxhzhuanfa_thumb.gif", title:"转发"},
                {url:"http://www.rujiaowang.net/space/img/emoji/lxhluguo_thumb.gif", title:"路过这儿"},
                {url:"http://www.rujiaowang.net/space/img/emoji/bofubianlian_thumb.gif", title:"bofu变脸"},
                {url:"http://www.rujiaowang.net/space/img/emoji/gbzkun_thumb.gif", title:"gbz困"},
                {url:"http://www.rujiaowang.net/space/img/emoji/boboshengmenqi_thumb.gif", title:"生闷气"},
                {url:"http://www.rujiaowang.net/space/img/emoji/chn_buyaoya_thumb.gif", title:"不要啊"},
                {url:"http://www.rujiaowang.net/space/img/emoji/daxiongleibenxiong_thumb.gif", title:"泪奔"},
                {url:"http://www.rujiaowang.net/space/img/emoji/cat_yunqizhong_thumb.gif", title:"运气中"},
                {url:"http://www.rujiaowang.net/space/img/emoji/youqian_thumb.gif", title:"有钱"},
            ]
        }
    },
    mounted(){
    },
    methods:{
        //点击小图标事件
        dianji:function(index) {
            var simg = this.$refs.src
            this.$emit('renoav',false)
            VueEvent.$emit('expression', simg[index])
        },
    },
}
</script>

<style lang="less" scoped>
.face {
	width: 390px;
	background: #fff;
	border: 1px solid #ddd;
    box-shadow: 0 0 12px #666;
    background-color: #000;
    ul {
        background-color: #eee;
        li{
            float: left;
            background-color: #fff;
            img{
                margin: 5px;
            }
        }
    }
}
</style>
